import React from 'react';
import {
  Newspaper,
  BookOpen,
  Phone,
  Users,
  Globe,
  ChevronDown,
  Lock
} from 'lucide-react';
import Language from '../language/Language';
import { useIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { useLanguage } from '../../context';
import { getLocalizedPath } from '../../helpers/routes';

// Custom styles for hiding scrollbar
const styles = `
  .scrollbar-hide {
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;     /* Firefox */
  }
  .scrollbar-hide::-webkit-scrollbar {
    display: none;  /* Safari and Chrome */
  }
`;

// Top navigation bar component
const TopBar = ({ className, globalData, hidden = false }) => {
  const intl = useIntl();
  const { language } = useLanguage();

  // Inject custom styles
  if (typeof document !== 'undefined') {
    const styleId = 'topbar-scrollbar-styles';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = styles;
      document.head.appendChild(style);
    }
  }

return (
    <div className={`bg-[#0a1628] overflow-hidden transition-all duration-300 ease-in-out ${hidden ? 'max-h-0' : 'max-h-10'} ${className || ''}`}>
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12">
      <ul className="flex items-center lg:justify-end space-x-5 lg:space-x-7 text-sm overflow-x-auto whitespace-nowrap scrollbar-hide py-2">
        <li>
          <NavLink
            to={getLocalizedPath("/news", language)}
            className={({ isActive }) => `flex items-center space-x-1 transition-all duration-200 ${
              isActive 
                ? 'text-[#16A34A] font-semibold ' 
                : 'text-slate-400 hover:text-white'
            }`}
          >
            <Newspaper size={16} />
            <span>{intl.formatMessage({ id: "nav.news" })}</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to={getLocalizedPath("/blog", language)}
            className={({ isActive }) => `flex items-center space-x-1 transition-all duration-200 ${
              isActive 
                ? 'text-[#16A34A] font-semibold ' 
                : 'text-slate-400 hover:text-white'
            }`}
          >
            <BookOpen size={16} />
            <span>{intl.formatMessage({ id: "nav.blog" })}</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to={getLocalizedPath("/contact", language)}
            className={({ isActive }) => `flex items-center space-x-1 transition-all duration-200 ${
              isActive 
                ? 'text-[#16A34A] font-semibold ' 
                : 'text-slate-400 hover:text-white'
            }`}
          >
            <Phone size={16} />
            <span>{intl.formatMessage({ id: "nav.contact" })}</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to={getLocalizedPath("/partners", language)}
            className={({ isActive }) => `flex items-center space-x-1 transition-all duration-200 ${
              isActive
                ? 'text-[#16A34A] font-semibold '
                : 'text-slate-400 hover:text-white'
            }`}
          >
            <Users size={16} />
            <span>{intl.formatMessage({ id: "nav.partners" })}</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to={getLocalizedPath("/careers", language)}
            className={({ isActive }) => `flex items-center space-x-1 transition-all duration-200 ${
              isActive
                ? 'text-[#16A34A] font-semibold '
                : 'text-slate-400 hover:text-white'
            }`}
          >
            <Globe size={16} />
            <span>{intl.formatMessage({ id: "nav.careers" })}</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/admin/login"
            className={({ isActive }) => `flex items-center space-x-1 transition-all duration-200 ${
              isActive
                ? 'text-[#16A34A] font-semibold '
                : 'text-slate-400 hover:text-white'
            }`}
          >
            <Lock size={16} />
            <span>{intl.formatMessage({ id: "nav.portal" })}</span>
          </NavLink>
        </li>
        <li className="flex items-center text-white/20">
          <span>|</span>
        </li>
        <li>
          <Language invert />
        </li>
      </ul>
      </div>
    </div>
  );
};

export default TopBar;
